import React, { useRef, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";

const PrintLabelModal = ({ show, onClose, product, onMarkPrinted }) => {
  const printRef = useRef();
  const [processing, setProcessing] = useState(false);

  const markPrintedOnce = () => {
    if (!processing) {
      setProcessing(true);
      onMarkPrinted(product);
      onClose();
    }
  };

  const downloadLabelFile = () => {
  if (product?.label_file && product.label_file.url) {
    const url = product.label_file.url;
    window.open(url, "_blank");
  }else{
    toast.error("Label file not available for download.");
  }
};

  const handleDownloadPDF = () => {
    downloadLabelFile();
    markPrintedOnce();
  };

  const handlePrint = () => {
    downloadLabelFile();
    markPrintedOnce();
  };

  return (
    <>
    <Modal show={show} onHide={onClose} size="md" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Product Details</Modal.Title>
      </Modal.Header>

      <Modal.Body ref={printRef}>
        <h5>{product.product_name}</h5>
        <p><strong>Warehouse:</strong> {product.wearhouse_name}</p>
        <p><strong>Address:</strong> {product.wearhouse_address}</p>
        <p><strong>Qty:</strong> {product.product_qty}</p>
        <p><strong>User:</strong> {product.user_name}</p>
        <p><strong>Label Name:</strong> {product.label_name}</p>
        <p><strong>Extract No:</strong> {product.label_extract_no}</p>
        <p><strong>Upload Date:</strong> {product.label_upload_date}</p>
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="primary"
          onClick={handleDownloadPDF}
          disabled={processing}
        >
          Download PDF
        </Button>

        <Button
          variant="secondary"
          onClick={handlePrint}
          disabled={processing}
        >
          Print
        </Button>
      </Modal.Footer>
    </Modal>
    </>
  );
};

export default PrintLabelModal;
